<template>
    <div id="app">
        <main-header nowtab="index"></main-header>
        <main class="adjuster" v-if="!mobile">
            <div class="left-list">
                <a-card size="small" title="公告" :bordered="false" class="card">
                    <div class="announcement" v-html="announcement"></div>
                </a-card>
                <a-card v-if="recommend" size="small" title="今日推荐" :bordered="false" class="card">
                    <div class="tower-card-container">
                        <tower-card-lite :tower="recommend"/>
                    </div>
                </a-card>
                <a-card size="small" :bordered="false" class="card">
                    <div class="search-bar">
                        <a-input-search placeholder="查找魔塔" enter-button @search="search"/>
                    </div>
                    <div class="dailyTower">
                        每日随机推荐:  
                        <tower-tag v-for="tower of dailyTowers" :key="tower.name" v-bind="tower" />
                    </div>
                </a-card>
                <a-card title="动态" size="small" :bordered="false" class="card feed-card">
                    <p>动态功能开发中</p>
                </a-card>
            </div>
            <div class="right-list">
                <competition-card
                    v-for="competition of competitions" :key="competition.id" class="card"
                    v-bind="competition"
                />
                <a-card title="随机玩塔" size="small" :bordered="false" class="card roll-card">
                    <a slot="extra" @click="rollTower">
                        <a-icon type="sync" :spin="rolling"/> 换一个
                    </a>
                    <tower-tag v-if="randTower" v-bind="randTower" />
                </a-card>
                <div class="card hotspot-card">
                    <a-tabs size="small" default-active-key="1">
                        <a-tab-pane key="1" tab="最热">
                            <a-list size="small" :data-source="hotest">
                                <tower-item slot="renderItem" slot-scope="item" v-bind="item" />
                            </a-list>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="最新">
                            <a-list size="small" :data-source="latest">
                                <tower-item slot="renderItem" slot-scope="item" v-bind="item" />
                            </a-list>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
        </main>
        <main class="adjuster" v-else>
            <div class="mobile-list">
                <a-card size="small" title="公告" :bordered="false" class="card">
                    <div class="announcement" v-html="announcement"></div>
                </a-card>
                <competition-card
                    v-for="competition of competitions" :key="competition.id" class="card"
                    v-bind="competition"
                />
                <!-- <a-card v-if="recommend" size="small" title="今日推荐" :bordered="false" class="card"> -->
                    <div v-if="recommend" class="tower-card-container">
                        <tower-card-lite :tower="recommend"/>
                    </div>
                <!-- </a-card> -->
                <a-card size="small" :bordered="false" class="card">
                    <div class="search-bar">
                        <a-input-search placeholder="查找魔塔" enter-button @search="search"/>
                    </div>
                    <div class="dailyTower">
                        每日随机推荐:  
                        <tower-tag v-for="tower of dailyTowers" :key="tower.name" v-bind="tower" />
                    </div>
                </a-card>
                <a-card title="随机玩塔" size="small" :bordered="false" class="card roll-card">
                    <a slot="extra" @click="rollTower">
                        <a-icon type="sync" :spin="rolling"/> 换一个
                    </a>
                    <tower-tag v-if="randTower" v-bind="randTower" />
                </a-card>
                <div class="card hotspot-card">
                    <a-tabs size="small" default-active-key="1">
                        <a-tab-pane key="1" tab="最热">
                            <a-list size="small" :data-source="hotest.slice(0, 5)">
                                <tower-item slot="renderItem" slot-scope="item" v-bind="item" />
                            </a-list>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="最新">
                            <a-list size="small" :data-source="latest.slice(0, 5)">
                                <tower-item slot="renderItem" slot-scope="item" v-bind="item" />
                            </a-list>
                        </a-tab-pane>
                    </a-tabs>
                </div>
                <a-card title="动态" size="small" :bordered="false" class="card feed-card">
                    <p>动态功能开发中</p>
                </a-card>
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import TowerTag from '@/components/TowerTag.vue';
import TowerItem from '@/components/TowerItem.vue';
import CompetitionCard from '@/components/CompetitionCard.vue';
import axios from 'axios';
import TowerCardLite from '../../components/TowerCardLite.vue';

const handle = window.matchMedia('(max-width: 599px)');

export default {
    data: () => ({
        dailyTowers: [],
        recommend: null,
        randTower: null,
        competitions: [],
        rightListTab: 'hotest',
        hotest: [],
        latest: [],
        announcement: "",
        rolling: false,
        mobile: handle.matches,
    }),
    async created() {
        const [
            { data: { rand: dailyTowers, recommend } },
            { data: { hotest, latest } },
            { data: { competition } },
            { data: { announcement } },
        ] = await Promise.all([
            axios.get("/backend/towers/daily.php"),
            axios.get("/backend/towers/hotspot.php"),
            axios.get("/backend/main/competition.php"),
            axios.get("/backend/main/announcement.php"),
        ])
        this.dailyTowers = dailyTowers;
        this.recommend = recommend;
        this.hotest = hotest;
        this.latest = latest;
        this.competitions = competition;
        this.announcement = announcement;
        this.rollTower();
        // getSSRdata();
        handle.onchange = (e) => this.mobile = e.matches;
    },
    methods: {
        onTabChange(key) {
            this.rightListTab = key;
        },
        async rollTower() {
            if (this.rolling) return;
            this.rolling = true;
            const { data } = await axios.get("/backend/towers/rand.php", {
                params: { count: 1 }
            });
            this.randTower = data.towers[0];
            this.rolling = false;
        },
        search(value) {
            window.open(`/play/?q=${ encodeURI(value) }`);
        }
    },
    components: {
        MainHeader, Footer, TowerTag, TowerItem, CompetitionCard, TowerCardLite,
    },
};
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #e6e6e6 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    @media screen and (min-width: 1000px) {
        margin: 20px auto;
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        margin: 0 auto;
        width: 100%;
    }
    display: flex;
}
.left-list {
    flex-grow: 1;
}
.search-bar {
    margin: auto;
    max-width: 500px;
}
.right-list {
    width: 256px;
    min-width: 256px;
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.announcement {
    text-align: left;
}
.dailyTower {
    margin: 5px 5px 0 ;
    text-align: left;
    line-height: 2;
}
.feed-card {
    text-align: left;
}
.tower-card-container {
    width: fit-content;
    margin: auto;
}
.mobile-list {
    width: 100%;
}
</style>

<style scoped>
.left-list >>> .ant-card-head-title {
    text-align: left;
}
.roll-card >>> .ant-card-head-title {
    text-align: left;
}
.hotspot-card >>> .ant-list {
    text-align: left;
}
</style>

